import { EStavPozadavky } from 'enums/statniSprava/stavPozadavky';

const stavPozadavkySelect = [
    {
        value: EStavPozadavky.ODESLAT,
        labelcz: 'ODESLAT'
    },
    {
        value: EStavPozadavky.CEKAJICI,
        labelcz: 'CEKAJICI'
    },
    {
        value: EStavPozadavky.DORUCEN,
        labelcz: 'DORUCEN'
    },
    {
        value: EStavPozadavky.ZODPOVEZEN,
        labelcz: 'ZODPOVEZEN'
    },
    {
        value: EStavPozadavky.CEKANAZPRAC,
        labelcz: 'CEKANAZPRAC'
    },
    {
        value: EStavPozadavky.ZRUSEN,
        labelcz: 'ZRUSEN'
    }
];

export default stavPozadavkySelect;
